import Vue from 'vue'
import Element from 'element-ui'
// import Element from './m-element/lib/element-ui.common.js'
import './element-variables.scss'

Vue.use(Element)
